import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Instagram, Facebook, Twitter, Linkedin, MapPin, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#040B16] text-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Sparkles className="w-5 h-5 text-[#D4AF37]" />
            <div className="font-display font-extrabold text-lg">Global Prime Fleet</div>
          </div>
          <p className="text-sm text-white/60 leading-relaxed">
            Drive Excellence. Anywhere. Anytime. Premium car rentals for every journey — business, leisure and unforgettable moments.
          </p>
          <div className="flex gap-3 mt-5">
            {[Instagram, Facebook, Twitter, Linkedin].map((Icon, i) => (
              <a key={i} href="#" data-testid={`footer-social-${i}`} className="w-9 h-9 rounded-full border border-white/15 grid place-items-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="eyebrow mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/fleet" className="hover:text-[#D4AF37]">Fleet</Link></li>
            <li><Link to="/services" className="hover:text-[#D4AF37]">Services</Link></li>
            <li><Link to="/about" className="hover:text-[#D4AF37]">About</Link></li>
            <li><Link to="/gallery" className="hover:text-[#D4AF37]">Gallery</Link></li>
            <li><Link to="/faq" className="hover:text-[#D4AF37]">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#D4AF37] shrink-0" /> 500 North Central Expressway, Suite 500, Plano, TX 75074 US</li>
            <li className="flex gap-2"><Phone className="w-4 h-4 mt-0.5 text-[#D4AF37]" /> +1 (682) 449-4920</li>
            <li className="flex gap-2"><Mail className="w-4 h-4 mt-0.5 text-[#D4AF37]" /> info@globalprimefleet.com</li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">Business Hours</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Monday — Friday</li>
            <li className="text-white">8:30 am — 5:00 pm</li>
            <li className="mt-3">Saturday & Sunday</li>
            <li>By appointment</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Global Prime Fleet. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-[#D4AF37]">Privacy Policy</a>
            <a href="#" className="hover:text-[#D4AF37]">Terms & Conditions</a>
            <a href="#" className="hover:text-[#D4AF37]">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
